import { render } from "./SurveyRevisionHeader.vue?vue&type=template&id=bb413c8c"
import script from "./SurveyRevisionHeader.vue?vue&type=script&lang=js"
export * from "./SurveyRevisionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__